import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { HeadlessForm } from '@universal-ember/form';

const CustomInput = <template>
  <input
    value={{@value}}
    class="border-2 border-purple-500 rounded px-2"
    {{on "input" (pick "target.value" @onChange)}}
    ...attributes
  />
</template>;

function pick(path, action) {
  return (event) => {
    let value = path.split('.').reduce((obj, key) => obj?.[key], event);

    action(value);
  };
}

export default class MyFormComponent extends Component {
  data = { email: 'jane.doe@example.com' };

  handleSubmit = ({ email }) => {
    alert(`Form submitted with: ${email}`);
  };

  <template>
    <HeadlessForm @data={{this.data}} @onSubmit={{this.handleSubmit}} as |form|>
      <form.Field @name="email" as |field|>
        <div class="my-2 flex flex-col">
          <field.Label>Email</field.Label>
          <CustomInput
            @value={{field.value}}
            @onChange={{field.setValue}}
            id={{field.id}}
            type="email"
            name="email"
            placeholder="Enter your email address"
          />
        </div>
      </form.Field>

      <button type="submit">Submit</button>
    </HeadlessForm>
  </template>
}